{
    "dbp-modal": {
        "close": "Schließen"
    },
    "error": {
        "connection-to-server-refused": "Verbindungs zum Server verweigert!",
        "summary": "Ein Fehler ist aufgetreten"
    }
}
